import mergeDeepRight from 'ramda/src/mergeDeepRight'

const defaults = {
  end: {},
  location: [],
  locked: false,
  start: {},
  strokeColor: '#000000'
}

export const addWireDefaults = mergeDeepRight(defaults)
export default defaults



// WEBPACK FOOTER //
// ./src/helpers/wires/defaults.js